module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600.1ee41b36.ttf";